export const debug_log = (...values) => {
    typeof window !== 'undefined' && window.DEBUG && console.log(...values);
}


export const debug_error = (...values) => {
    typeof window !== 'undefined' && window.DEBUG && console.error(...values);
}


